export const parseLocaleString = (locale: string | number) => {
  if (typeof locale === 'string') {
    return parseFloat(locale?.replace(/\s/g, '').replace(/,/g, '.'));
  }

  return parseFloat(String(locale)?.replace(/\s/g, '').replace(/,/g, '.'));
};
